/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountInstanceInternalFull,
  DiscountInstanceInternalFullOptional,
  DiscountInstanceInternalFullMetaI,
  DiscountInstanceInternalFullTrackedI,
} from "./discount-instance-internal-full";
import {
  DiscountInstanceInternalFullTracked,
  DiscountInstanceInternalFullMeta,
} from "./discount-instance-internal-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountRef,
  DiscountRefOptional,
  DiscountRefMetaI,
  DiscountRefTrackedI,
} from "./discount-ref";
import { DiscountRefTracked, DiscountRefMeta } from "./discount-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";

/**
 *
 * @export
 * @interface CatalogDiscountInstanceDTO
 */
export interface CatalogDiscountInstanceDTOOptional extends DiscountInstanceInternalFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstanceDTO
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogDiscountInstanceDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstanceDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  autoApply?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isSpecial?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  universalCode?: string;
  /**
   *
   * @type {DiscountRef}
   * @memberof CatalogDiscountInstanceDTO
   */
  discountId?: DiscountRefOptional;
}

export interface CatalogDiscountInstanceDTO
  extends CatalogDiscountInstanceDTOOptional, DiscountInstanceInternalFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstanceDTO
   */
  instanceId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogDiscountInstanceDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstanceDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  autoApply?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isSpecial?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  universalCode?: string;
  /**
   *
   * @type {DiscountRef}
   * @memberof CatalogDiscountInstanceDTO
   */
  discountId?: DiscountRef;
}

export interface CatalogDiscountInstanceDTOTrackedI extends DiscountInstanceInternalFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstanceDTO
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogDiscountInstanceDTO
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstanceDTO
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  percent?: string;
  percentIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  autoApply?: boolean;
  autoApplyIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isGlobal?: boolean;
  isGlobalIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstanceDTO
   */
  isSpecial?: boolean;
  isSpecialIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstanceDTO
   */
  universalCode?: string;
  universalCodeIsSet: boolean;
  /**
   *
   * @type {DiscountRef}
   * @memberof CatalogDiscountInstanceDTO
   */
  discountId?: DiscountRefTrackedI;
  discountIdIsSet: boolean;
}

transformDatesMap.set(
  "CatalogDiscountInstanceDTO",
  function (model: CatalogDiscountInstanceDTO) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
    const transformDatesdiscountId = transformDatesMap.get("DiscountRef");
    if (transformDatesdiscountId && model.discountId) {
      transformDatesdiscountId(model.discountId);
    }
  },
);

export type CatalogDiscountInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  percent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  autoApply: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isGlobal: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isSpecial: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  universalCode: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountId: PropertyMeta<DiscountRefMetaI>;
}>;

export var CatalogDiscountInstanceDTOMeta: CatalogDiscountInstanceDTOMetaI =
  {} as CatalogDiscountInstanceDTOMetaI;
CatalogDiscountInstanceDTOMeta = typeMeta("CatalogDiscountInstanceDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  instanceId: propertyMeta(
    "instanceId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  discountType: propertyMeta(
    "discountType",
    false,
    false,
    false,
    DiscountTypeMeta,
  ),
  amountCents: propertyMeta(
    "amountCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  percent: propertyMeta("percent", false, false, false, MetaTypesBase.string),
  autoApply: propertyMeta(
    "autoApply",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isGlobal: propertyMeta(
    "isGlobal",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isSpecial: propertyMeta(
    "isSpecial",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  universalCode: propertyMeta(
    "universalCode",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  discountId: propertyMeta("discountId", false, false, false, DiscountRefMeta),
});

const metaI = CatalogDiscountInstanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    DiscountInstanceInternalFullMeta,
  ]);
  metaI.isDeleted.inheritedFrom = DiscountInstanceInternalFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = DiscountInstanceInternalFullMeta.isNew;
  metaI.tempID.inheritedFrom = DiscountInstanceInternalFullMeta.tempID;
  metaI.instanceId.inheritedFrom = DiscountInstanceInternalFullMeta.instanceId;
  metaI.startActive.inheritedFrom =
    DiscountInstanceInternalFullMeta.startActive;
  metaI.endActive.inheritedFrom = DiscountInstanceInternalFullMeta.endActive;
  metaI.discountType.inheritedFrom =
    DiscountInstanceInternalFullMeta.discountType;
  metaI.amountCents.inheritedFrom =
    DiscountInstanceInternalFullMeta.amountCents;
  metaI.percent.inheritedFrom = DiscountInstanceInternalFullMeta.percent;
  metaI.autoApply.inheritedFrom = DiscountInstanceInternalFullMeta.autoApply;
  metaI.isGlobal.inheritedFrom = DiscountInstanceInternalFullMeta.isGlobal;
  metaI.isSpecial.inheritedFrom = DiscountInstanceInternalFullMeta.isSpecial;
  metaI.universalCode.inheritedFrom =
    DiscountInstanceInternalFullMeta.universalCode;
  metaI.discountId.inheritedFrom = DiscountInstanceInternalFullMeta.discountId;
});

export class CatalogDiscountInstanceDTOTracked
  extends DiscountInstanceInternalFullTracked
  implements CatalogDiscountInstanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  instanceId__I?: number = undefined;

  get instanceIdIsSet() {
    return this.instanceId !== undefined;
  }
  set instanceIdIsSet(v: boolean) {}
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  percent__I?: string = undefined;
  percentIsSet: boolean = false;
  set percent(v: undefined | string) {
    if (v !== undefined) {
      this.percent__I = v;
      this.percentIsSet = true;
    } else {
      this.percent__I = v || undefined;
      this.percentIsSet = false;
    }
    this.changeTracker = true;
  }
  get percent() {
    return this.percent__I;
  }
  autoApply__I?: boolean = undefined;
  autoApplyIsSet: boolean = false;
  set autoApply(v: undefined | boolean) {
    if (v !== undefined) {
      this.autoApply__I = v;
      this.autoApplyIsSet = true;
    } else {
      this.autoApply__I = v || undefined;
      this.autoApplyIsSet = false;
    }
    this.changeTracker = true;
  }
  get autoApply() {
    return this.autoApply__I;
  }
  isGlobal__I?: boolean = undefined;
  isGlobalIsSet: boolean = false;
  set isGlobal(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGlobal__I = v;
      this.isGlobalIsSet = true;
    } else {
      this.isGlobal__I = v || undefined;
      this.isGlobalIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGlobal() {
    return this.isGlobal__I;
  }
  isSpecial__I?: boolean = undefined;
  isSpecialIsSet: boolean = false;
  set isSpecial(v: undefined | boolean) {
    if (v !== undefined) {
      this.isSpecial__I = v;
      this.isSpecialIsSet = true;
    } else {
      this.isSpecial__I = v || undefined;
      this.isSpecialIsSet = false;
    }
    this.changeTracker = true;
  }
  get isSpecial() {
    return this.isSpecial__I;
  }
  universalCode__I?: string = undefined;
  universalCodeIsSet: boolean = false;
  set universalCode(v: undefined | string) {
    if (v !== undefined) {
      this.universalCode__I = v;
      this.universalCodeIsSet = true;
    } else {
      this.universalCode__I = v || undefined;
      this.universalCodeIsSet = false;
    }
    this.changeTracker = true;
  }
  get universalCode() {
    return this.universalCode__I;
  }
  discountId__I?: DiscountRefTracked = undefined;
  discountIdIsSet: boolean = false;
  set discountId(v: undefined | DiscountRefTracked) {
    if (v !== undefined) {
      this.discountId__I = v;
      this.discountIdIsSet = true;
    } else {
      this.discountId__I = v || undefined;
      this.discountIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountId() {
    return this.discountId__I;
  }
  constructor(
    config?: CatalogDiscountInstanceDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;
    if (this.instanceIdIsSet == true && other?.instanceIdIsSet == true)
      return this.instanceId == other.instanceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.instanceId) {
      this.instanceIdIsSet = true;
    }

    this.discountId?.setIds();
  }
  assignFrom(
    config: CatalogDiscountInstanceDTOOptional,
    options?: AssignOptions,
  ): CatalogDiscountInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (config.percent && this.percentApplyFilter(optionsRequired.filter)) {
      this.percent = config.percent;
      if (optionsRequired.unassign) this.percentIsSet = false;
      else this.percentIsSet = true;
    }
    if (config.autoApply && this.autoApplyApplyFilter(optionsRequired.filter)) {
      this.autoApply = config.autoApply;
      if (optionsRequired.unassign) this.autoApplyIsSet = false;
      else this.autoApplyIsSet = true;
    }
    if (config.isGlobal && this.isGlobalApplyFilter(optionsRequired.filter)) {
      this.isGlobal = config.isGlobal;
      if (optionsRequired.unassign) this.isGlobalIsSet = false;
      else this.isGlobalIsSet = true;
    }
    if (config.isSpecial && this.isSpecialApplyFilter(optionsRequired.filter)) {
      this.isSpecial = config.isSpecial;
      if (optionsRequired.unassign) this.isSpecialIsSet = false;
      else this.isSpecialIsSet = true;
    }
    if (
      config.universalCode &&
      this.universalCodeApplyFilter(optionsRequired.filter)
    ) {
      this.universalCode = config.universalCode;
      if (optionsRequired.unassign) this.universalCodeIsSet = false;
      else this.universalCodeIsSet = true;
    }
    if (
      config.discountId &&
      this.discountIdApplyFilter(optionsRequired.filter)
    ) {
      this.discountId = new DiscountRefTracked(config.discountId, options);
      if (optionsRequired.unassign) this.discountIdIsSet = false;
      else this.discountIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogDiscountInstanceDTOTrackedI {
    const cloned = {} as CatalogDiscountInstanceDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.percentIsSetDeep() &&
      this.percentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.percentIsSet = true;
      cloned.percent = this.percent;
    } else {
      //cloned.percentIsSet = false
    }
    if (
      this.autoApplyIsSetDeep() &&
      this.autoApplyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.autoApplyIsSet = true;
      cloned.autoApply = this.autoApply;
    } else {
      //cloned.autoApplyIsSet = false
    }
    if (
      this.isGlobalIsSetDeep() &&
      this.isGlobalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGlobalIsSet = true;
      cloned.isGlobal = this.isGlobal;
    } else {
      //cloned.isGlobalIsSet = false
    }
    if (
      this.isSpecialIsSetDeep() &&
      this.isSpecialApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isSpecialIsSet = true;
      cloned.isSpecial = this.isSpecial;
    } else {
      //cloned.isSpecialIsSet = false
    }
    if (
      this.universalCodeIsSetDeep() &&
      this.universalCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.universalCodeIsSet = true;
      cloned.universalCode = this.universalCode;
    } else {
      //cloned.universalCodeIsSet = false
    }
    if (
      this.discountIdIsSetDeep() &&
      this.discountIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountIdIsSet = true;
      cloned.discountId = this.discountId?.removeUnset(filter);
    } else {
      //cloned.discountIdIsSet = false
    }
    if (!isDeleted(this) && !this.instanceIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogDiscountInstanceDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.percentApplyFilter(filter)) this.percentIsSet = false;

    if (!this.autoApplyApplyFilter(filter)) this.autoApplyIsSet = false;

    if (!this.isGlobalApplyFilter(filter)) this.isGlobalIsSet = false;

    if (!this.isSpecialApplyFilter(filter)) this.isSpecialIsSet = false;

    if (!this.universalCodeApplyFilter(filter)) this.universalCodeIsSet = false;

    if (!this.discountIdApplyFilter(filter)) this.discountIdIsSet = false;
    this.discountId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.isDeleted,
      CatalogDiscountInstanceDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.isNew,
      CatalogDiscountInstanceDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.tempID,
      CatalogDiscountInstanceDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.instanceId,
      CatalogDiscountInstanceDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.startActive,
      CatalogDiscountInstanceDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.endActive,
      CatalogDiscountInstanceDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.discountType,
      CatalogDiscountInstanceDTOMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.amountCents,
      CatalogDiscountInstanceDTOMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  percentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.percent,
      CatalogDiscountInstanceDTOMeta,
      this.percent,
      this,
    );
  }
  percentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.percentIsSet && this.percentApplyFilter(filter)) return true;

    return false;
  }
  autoApplyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.autoApply,
      CatalogDiscountInstanceDTOMeta,
      this.autoApply,
      this,
    );
  }
  autoApplyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.autoApplyIsSet && this.autoApplyApplyFilter(filter)) return true;

    return false;
  }
  isGlobalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.isGlobal,
      CatalogDiscountInstanceDTOMeta,
      this.isGlobal,
      this,
    );
  }
  isGlobalIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGlobalIsSet && this.isGlobalApplyFilter(filter)) return true;

    return false;
  }
  isSpecialApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.isSpecial,
      CatalogDiscountInstanceDTOMeta,
      this.isSpecial,
      this,
    );
  }
  isSpecialIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isSpecialIsSet && this.isSpecialApplyFilter(filter)) return true;

    return false;
  }
  universalCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.universalCode,
      CatalogDiscountInstanceDTOMeta,
      this.universalCode,
      this,
    );
  }
  universalCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.universalCodeIsSet && this.universalCodeApplyFilter(filter))
      return true;

    return false;
  }
  discountIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstanceDTOMeta.discountId,
      CatalogDiscountInstanceDTOMeta,
      this.discountId,
      this,
    );
  }
  discountIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountIdIsSet && this.discountIdApplyFilter(filter)) return true;
    return this.discountId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.percentIsSetDeep(filter)) return true;
    if (this.autoApplyIsSetDeep(filter)) return true;
    if (this.isGlobalIsSetDeep(filter)) return true;
    if (this.isSpecialIsSetDeep(filter)) return true;
    if (this.universalCodeIsSetDeep(filter)) return true;
    if (this.discountIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
